import React from 'react';

import EmployerBalanceSpendContainer from './EmployerBalanceSpend.container';
import EmployerClaimSpendNotionalContainer from './EmployerClaimSpendNotional.container';
interface Props {
  isLoading?: boolean;
  isHSA?: boolean;
  planId: string;
}
const EmployerClaimSpendContainer: React.FC<Props> = ({ isHSA, isLoading, planId }) => {
  if (isLoading) {
    return null;
  }
  if (isHSA) {
    return <EmployerBalanceSpendContainer planId={planId} />;
  }

  return <EmployerClaimSpendNotionalContainer isLoading={isLoading} planId={planId} />;
};
export default EmployerClaimSpendContainer;
